
const Months = [
    'Jan',
    'Feb',
    'March',
    'April',
    'May',
    'June',
    'July',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec',
];

export default Months;


// WEBPACK FOOTER //
// ./src/base/scripts/helpers/months.js